export const ENVIRONMENT_DEVELOPMENT =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development";


export const API_BASE_DOMAIN = (ENVIRONMENT_DEVELOPMENT
  ? process.env.REACT_APP_API_HOST || "http://localhost:8000"
  : window.location.origin) + "/api";

export const API_AUTH_URI = API_BASE_DOMAIN + "/saml2/authenticate/okta-saml";

export const API_USER_DOMAIN = API_BASE_DOMAIN + "/user";

export const API_CLIENT_DOMAIN = API_BASE_DOMAIN + "/client";

export const USER_TOKEN_NAME = "token";

export const DEFAULT_PAGE_SIZE = 5;

export const COLUMN_TYPE = {
  TEXT: "text",
  TEXT_TRANSLATABLE: "text_translatable",
  DATE: "date",
  COMPONENT: "component",
  STATUS: "status",
};

export const LAYOUT_TYPE = {
  INITIAL_PAGE: "initial-page",
  INNER_PAGE: "inner-page",
  INNER_PAGE_LOADING: "inner-page-loading",
  FORM_PAGE: "form-page",
  LOGIN_PAGE: "login-page",
};

export const SORT_TYPE = {
  ASCENDING: "ASC",
  DESCENDING: "DESC",
};

export const FILTER_INPUT_TYPE = {
  TEXT: "text",
  MULTI_SELECT: "multi-select",
};

export const FILTER_ACTION_TYPE = {
  CLEAR: "clear",
  APPLY: "apply",
};

export const PATTERN = {
  ANY: ".*",
  URL: "[Hh][Tt][Tt][Pp][Ss]?://(?:(?:[a-zA-Z\u00a1-\uffff0-9]+-?)*[a-zA-Z\u00a1-\uffff0-9]+)(?:.(?:[a-zA-Z\u00a1-\uffff0-9]+-?)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:.(?:[a-zA-Z\u00a1-\uffff]{2,}))(?::d{2,5})?(?:/[^s]*)?",
  PACKAGE: "^[a-z0-9]+[a-z0-9\\-\\+\\.]*$",
  VERSION: "^(0|[1-9]\\d*)\\.(0|[1-9]\\d*)\\.(0|[1-9]\\d*)(?:-((?:0|[1-9]\\d*|\\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\\.(?:0|[1-9]\\d*|\\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\\+([0-9a-zA-Z-]+(?:\\.[0-9a-zA-Z-]+)*))?$"
};

export const SUCCESS_MESSAGE_TIMEOUT = 3000;

export const SLACK_WEBHOOKS_DOCS_URL =
  "https://api.slack.com/messaging/webhooks";
